var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreLocation4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.384644,
    width: 27,
    height: 27,
    rx: 5,
    fill: "#85BE49"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.0346C20 10.1614 19.8319 9.29661 19.5052 8.4898C19.1786 7.68298 18.6998 6.94989 18.0962 6.33238C17.4926 5.71487 16.7761 5.22504 15.9874 4.89084C15.1988 4.55665 14.3536 4.38464 13.5 4.38464C12.6464 4.38464 11.8012 4.55665 11.0126 4.89084C10.2239 5.22504 9.50739 5.71487 8.90381 6.33238C8.30023 6.94989 7.82144 7.68298 7.49478 8.4898C7.16813 9.29661 7 10.1614 7 11.0346C7 12.3523 7.37979 13.5778 8.02607 14.6114H8.01864L13.5 23.3846L18.9814 14.6114H18.9749C19.6442 13.5441 20 12.3027 20 11.0346ZM13.5 13.8846C12.7612 13.8846 12.0526 13.5844 11.5302 13.0499C11.0078 12.5154 10.7143 11.7905 10.7143 11.0346C10.7143 10.2788 11.0078 9.55387 11.5302 9.01939C12.0526 8.48491 12.7612 8.18464 13.5 8.18464C14.2388 8.18464 14.9474 8.48491 15.4698 9.01939C15.9922 9.55387 16.2857 10.2788 16.2857 11.0346C16.2857 11.7905 15.9922 12.5154 15.4698 13.0499C14.9474 13.5844 14.2388 13.8846 13.5 13.8846Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreLocation4);
export default __webpack_public_path__ + "static/media/StoreLocation4.a086671aa3788bb85679a619a9fe9586.svg";
export { ForwardRef as ReactComponent };